/* Copyright (c) 2022 Xperi. All Rights Reserved. */

// TODO: We should remove the disbaled linters once we use these enums.
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum VideoPlaybackType {
    IDLE,
    LIVE_TV,
    IP_STREAM,
}
